<div class="footer hide-sm">
  <div class="row justify-content-center align-items-center">
    <div class="col-6">
      <div class="text-left">
        <a href='{{environments.privacypolicyUrl}}' class="footer-font" rel="noopener noreferrer" target="blank">{{labels.privacyPolicy|translate}}</a>
        <a href='{{environments.legalUrl}}' class="footer-font" rel="noopener noreferrer" target="blank">{{labels.termsAndCondition | translate}}</a>
      </div>
    </div><div class="col-6">
      <div class="text-right">
        <a class="footer-font txt-decoration-none" href="">
          © {{currentYear}}, Schneider Electric
        </a>
      </div>
    </div>
  </div>
</div>
